import { fromJS, Map as IMap } from 'immutable';



export const PROMO_STORE_KEY = 'promo';
export const ACTIVE_PROMO = 'activePromo';
export const PROMO_ERROR = 'promoError';
export const PROMO_STATUS = 'promoStatus';
export const PROMO_REWARDS = 'rewards';
export const PROMO_REWARDS_STATE = 'requestState';
export const DIGITAL_PROMO_REWARD_CARDS = 'electronicRewardCards';
export const PLASTIC_PROMO_REWARD_CARDS = 'physicalRewardCards';
export const SHIPPING_PROMO_REWARDS = 'promotionalShippingData';
export const ACCESSORY_PROMO_REWARDS = 'promotionalAccessoryData';
export const DISCOUNT_PROMO_REWARD = 'totalDiscountRewardAmount';
export const REJECTED_PROMO_CODE = 'rejectedPromoCode';

export const PROMO_CERT_TYPE = {
    DIGITAL: 'ELEC',
    PHYSICAL: 'PLST'
};

export const REWARDS_REQUEST_STATE = {
    ACTIVE: 'active',
    FAILED: 'failed',
    SUCCESS: 'success'
};


export const INVALID_PROMO_ERROR = 'promo_invalid';
export const EXPIRED_PROMO_ERROR = 'promo_expired';
export const SOLD_OUT_PROMO_ERROR = 'promo_sold_out';
export const PROMO_VALID_SUCCESS = 'promo_valid_success';


export const GET_DEFAULT_PROMO = '@@storefront/GET_DEFAULT_PROMO';
export const GET_INITIAL_PROMO = '@@storefront/GET_INITIAL_PROMO';
export const FINISH_GET_PROMO = '@@storefront/FINISH_GET_PROMO';
export const GET_PROMO_FOR_CODE = '@@storefront/GET_PROMO_FOR_CODE';
export const APPLY_ACTIVE_PROMO = '@@storefront/APPLY_PROMO';
export const RESET_PROMO = '@@storefront/RESET_PROMO';
export const APPLY_ACTIVE_PROMO_PRE_CART = '@@storefront/APPLY_ACTIVE_PROMO_PRE_CART';
export const RECEIVED_PROMO_REWARDS = '@@storefront/RECEIVED_PROMO_REWARDS';


export const SET_ACTIVE_PROMO = '@@storefront/SET_ACTIVE_PROMO';
export const SET_PROMO_ERROR = '@@storefront/SET_PROMO_ERROR';
export const SET_PROMO_STATUS = '@@storefront/SET_PROMO_STATUS';
export const SET_PROMO_REWARDS = '@@storefront/SET_PROMO_REWARDS';
export const REMOVE_PROMO_REWARDS = '@@storefront/REMOVE_PROMO_REWARDS';
export const SET_REJECTED_PROMO = '@@storefront/SET_REJECTED_PROMO';
export const CLEAR_REJECTED_PROMOS = '@@storefront/CLEAR_REJECTED_PROMO';
export const SET_REWARDS_REQUEST_STATE = '@@storefront/SET_REWARDS_REQUEST_STATE';

export const initialState = IMap();




export default function promoReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ACTIVE_PROMO: {
            return state.set(ACTIVE_PROMO, fromJS(action.promo));
        }
        case SET_PROMO_ERROR: {
            const { codeOrDefault, error } = action;
            return state.update(PROMO_ERROR, (errorMap = IMap()) => errorMap.merge({ [codeOrDefault]: error }));
        }
        case SET_PROMO_STATUS: {
            return state.set(PROMO_STATUS, fromJS(action.status));
        }
        case SET_REWARDS_REQUEST_STATE: {
            return state.setIn([PROMO_REWARDS, PROMO_REWARDS_STATE], action.state);
        }
        case SET_PROMO_REWARDS: {
            return state
                .set(PROMO_REWARDS,
                    fromJS(action.rewards).merge({ [PROMO_REWARDS_STATE]: REWARDS_REQUEST_STATE.SUCCESS }));
        }
        case REMOVE_PROMO_REWARDS: {
            return state.delete(PROMO_REWARDS);
        }
        case SET_REJECTED_PROMO: {
            
            const stateWithoutActivePromo = state.delete(ACTIVE_PROMO);
            return stateWithoutActivePromo.set(REJECTED_PROMO_CODE, fromJS(action.rejectedPromoCode));
        }
        case CLEAR_REJECTED_PROMOS: {
            return state
                .delete(PROMO_ERROR)
                .delete(REJECTED_PROMO_CODE);
        }
        default:
            return state;
    }
}



export function setPromo(promo) {
    return {
        type: SET_ACTIVE_PROMO,
        promo
    };
}


export function clearActivePromo() {
    return {
        type: SET_ACTIVE_PROMO,
        promo: {}
    };
}


export function setPromoError(codeOrDefault, error) {
    return {
        type: SET_PROMO_ERROR,
        codeOrDefault,
        error
    };
}


export function setPromoStatus(status) {
    return {
        type: SET_PROMO_STATUS,
        status
    };
}


export function clearPromoStatus() {
    return {
        type: SET_PROMO_STATUS,
        status: null
    };
}


export function resetPromo() {
    return {
        type: RESET_PROMO
    };
}


export const getDefaultPromo = () => ({ type: GET_DEFAULT_PROMO });


export const getPromoForCode = promoCode => ({
    type: GET_PROMO_FOR_CODE,
    promoCode
});


export const getInitialPromo = () => ({
    type: GET_INITIAL_PROMO
});

export const applyActivePromo = () => ({
    type: APPLY_ACTIVE_PROMO
});


export const applyActivePromoPreCart = (includeAllItems, skipDigital, isApplicableShipping = false) => ({
    type: APPLY_ACTIVE_PROMO_PRE_CART,
    includeAllItems,
    skipDigital,
    isApplicableShipping
});


export const setPromoRewards = rewards => ({
    type: SET_PROMO_REWARDS,
    rewards
});


export const removePromoRewards = () => ({
    type: REMOVE_PROMO_REWARDS
});


export const setRejectedPromo = rejectedPromoCode => ({
    type: SET_REJECTED_PROMO,
    rejectedPromoCode
});


export const clearRejectedPromos = () => ({
    type: CLEAR_REJECTED_PROMOS
});


export const finishPromoLoad = () => ({ type: FINISH_GET_PROMO });


export const finishedGettingPromoRewards = () => ({
    type: RECEIVED_PROMO_REWARDS
});


export const setRewardsRequestActive = () => ({
    type: SET_REWARDS_REQUEST_STATE,
    state: REWARDS_REQUEST_STATE.ACTIVE
});


export const setRewardsRequestFailure = () => ({
    type: SET_REWARDS_REQUEST_STATE,
    state: REWARDS_REQUEST_STATE.FAILED
});
